export default __webpack_public_path__ + "static/media/rules-of-winning-chess.e8e35185.webp";